import React from "react";

const HoldingsSection = ({
  containerColor,
  containerBorderColor,
  valueAmount = "504.00",
  cashAmount = "0.00",
  textColor,
  gradientColors
}) => {
  // Build gradient string if gradientColors provided
  const buildGradientString = (colors) => {
    if (!colors || colors.length === 0) return null;
    if (colors.length === 1) return `linear-gradient(135deg, ${colors[0]}, ${colors[0]})`;
    
    const colorStops = colors.map((color, index) => {
      const percentage = (index / (colors.length - 1)) * 100;
      return `${color} ${percentage}%`;
    }).join(", ");
    
    return `linear-gradient(135deg, ${colorStops})`;
  };

  const backgroundStyle = gradientColors && gradientColors.length > 0
    ? { background: buildGradientString(gradientColors) }
    : { background: containerColor || "transparent" };

  return (
    <div style={{ padding: "0 8px", marginBottom: "8px" }}>
      <div
        style={{
          borderRadius: "20px",
          padding: "8px",
          display: "flex",
          opacity: 1,
          ...backgroundStyle,
          border: `1px solid ${containerBorderColor || "rgba(255, 255, 255, 0.3)"}`,
        }}
      >
        <div style={{ flex: 1, textAlign: "center" }}>
          <div
            style={{
              color: textColor,
              fontSize: "10px",
              fontWeight: "400",
            }}
          >
            Value of holdings
          </div>
          <div
            style={{
              color: textColor,
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            ₹ {valueAmount}
          </div>
        </div>

        {/* Divider */}
        <div
          style={{
            width: "1px",
            background: "rgba(255, 255, 255, 0.2)",
            margin: "0 20px",
          }}
        />

        <div style={{ flex: 1, textAlign: "center" }}>
          <div
            style={{
              color: textColor,
              fontSize: "10px",
        
              fontWeight: "400",
            }}
          >
            Cash Balance
          </div>
          <div
            style={{
              color: textColor,
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            ₹ {cashAmount}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HoldingsSection;
